import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SectionLink } from './SectionLink';
const navItems = [{
  label: 'About',
  id: 'about'
}, {
  label: 'Experience',
  id: 'experience'
}, {
  label: 'Skills',
  id: 'skills'
}, {
  label: 'Impact',
  id: 'impact'
}, {
  label: 'Track Record',
  id: 'career'
}, {
  label: 'Board',
  id: 'board'
}];
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full border-b transition-colors duration-200 ease-exec ${scrolled ? 'border-line bg-paper/95 backdrop-blur' : 'border-transparent bg-paper'}`} data-id="element-161" data-mp="zwsocob8szjx">
      <div className="mx-auto flex h-20 max-w-shell items-center justify-between gap-8 px-6 lg:px-10" data-id="element-162" data-mp="2bbfm87anbbk0">
        <Link to="/" className="flex items-baseline gap-3" data-id="element-163" data-mp="29isctsq3ihov">
          <span className="font-display text-lg font-semibold tracking-tight text-navy-900" data-id="element-164" data-mp="2eiws5ff9p6di">
            William R. Evans
          </span>
          <span className="hidden text-xs font-medium uppercase tracking-[0.14em] text-gold-600 xl:inline" data-id="element-165" data-mp="2jj1cxhn7kn9j">
            Board &amp; Advisory
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-7 lg:flex" data-id="element-166" data-mp="1qtuesjro1zot">
          {navItems.map(item => <SectionLink key={item.id} id={item.id} className="whitespace-nowrap text-sm font-medium text-muted transition-colors duration-150 ease-exec hover:text-navy-900 focus-visible:text-navy-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 focus-visible:ring-offset-4 focus-visible:ring-offset-paper" data-id="element-167" data-mp="1vtgseubephy5">
              {item.label}
            </SectionLink>)}
          <SectionLink id="contact" className="whitespace-nowrap border border-navy-900 px-4 py-2 text-sm font-semibold text-navy-900 transition-colors duration-150 ease-exec hover:bg-navy-900 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 focus-visible:ring-offset-2" data-id="element-168" data-mp="15187ylog7q3x">
            Board Inquiry
          </SectionLink>
        </nav>

        <SectionLink id="contact" className="whitespace-nowrap border border-navy-900 px-4 py-2 text-sm font-semibold text-navy-900 lg:hidden" data-id="element-169" data-mp="m2437p3xwii2">
          Inquiry
        </SectionLink>
      </div>
    </header>;
}